import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useSupabaseUser } from "./use-supabase-user";

export const useClientTeams = () => {
  const { user } = useSupabaseUser();

  const query = useQuery({
    queryKey: ["clientTeams", user?.id],
    queryFn: async () => {
      if (!user?.id) return { teams: [], isClient: false };

      const { data: clientTeams, error } = await supabase
        .from('client_teams')
        .select('team_id')
        .eq('client_id', user.id);

      if (error) throw error;

      return {
        teams: clientTeams?.map(ct => ct.team_id) || [],
        isClient: (clientTeams?.length || 0) > 0
      };
    },
    enabled: !!user?.id,
    staleTime: 120_000, // 2 minutes
    gcTime: 600_000, // 10 minutes cache
  });

  return {
    teams: query.data?.teams || [],
    isClient: query.data?.isClient || false,
    isLoading: query.isLoading,
    error: query.error,
  };
};